import CRUDActions from '../CRUD';
import FafFeedPost from '../../api/fan_feed/fan_feed_posts';

class FafFeedPostCrud extends CRUDActions {
  prefix = 'fan_feed_posts';

  get _model() {
    return FafFeedPost;
  }

}

export default new FafFeedPostCrud();




// WEBPACK FOOTER //
// ./src/actions/fan_feed/fan_feed_posts.ts